export default __webpack_public_path__ + "static/intro-products-b9499c2f21d60d877b4be8cd76b5b1bc.jpg";